import { useSuspenseQuery } from '@apollo/client'
import { FetchOrganizationSignInSettingsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, Logo } from '@salescore/client-common'
import { SignInByOauthCode, SignInBySalesforceOauth } from '@salescore/client-feature-setting'
import { getQueryParameter } from '@salescore/frontend-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { isNotNull } from 'effect/Predicate'
import type { ReactNode } from 'react'

import { SignIn } from '../../../components/SignIn.tsx'

//
// 組織ごとのログインページ。2023/01よりこちらを利用推奨。
// 現状だとルートの/sign_inとほぼ変わらないが、将来的に組織ごとにカスタマイズした認証画面を表示予定。
// （ログイン方法を組織ごとにカスタマイズしたい）
// 組織ごとのログインページではありつつ、複数組織にアカウントがある場合は、ログイン後に選択ページにリダイレクトされる
//
const Page = (): ReactNode => {
  const navigate = useNavigate()
  const {
    // isSalesforceOauthLoginOnly: 特定テナントについて、Auth0を経由しないOAuthのログインのみを許可する（海外サーバーを使えない特定テナントに向けた対応）
    data: { isSalesforceOauthLoginOnly },
  } = useSuspenseQuery(FetchOrganizationSignInSettingsDocument, {
    variables: {
      organizationId: getOrganizationIdFromPath(),
    },
  })

  const oauthCode = getQueryParameter('oauthCode')
  const provider = getQueryParameter('provider')
  const state = getQueryParameter('state')
  if (oauthCode !== null && oauthCode !== '' && provider !== null && provider !== '' && isNotNull(state)) {
    return (
      <SignInByOauthCode
        oauthCode={oauthCode}
        provider={provider}
        state={state}
        redirectToRoot={() => {
          void navigate({ to: '/' })
        }}
      />
    )
  }

  return (
    <div className="flex size-full flex-col items-center justify-center text-center align-middle">
      <div className="mb-8 w-64">
        <Logo />
      </div>
      <div style={{ width: 320, maxWidth: '100%', maxHeight: 500 }}>
        {isSalesforceOauthLoginOnly ? <SignInBySalesforceOauth /> : <SignIn />}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/o/$organizationId/sign_in')({
  component: Page,
})
